/**
 * 立减活动管理路由
 * 单独配置，不影响原有营销模块
 */
import Layout from '@/layout';
var instantDiscountRouter = {
  path: '/marketing/instantDiscount',
  component: Layout,
  redirect: '/marketing/instantDiscount/list',
  name: 'InstantDiscount',
  meta: {
    title: '立减活动管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    name: 'InstantDiscountList',
    component: function component() {
      return import('@/views/marketing/instantDiscount/index');
    },
    meta: {
      title: '立减活动列表',
      icon: ''
    }
  }
  // 路由会动态加载弹窗组件，无需在此配置
  ]
};
export default instantDiscountRouter;